var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3649",
    "data-name": "Group 3649",
    transform: "translate(-1308 -3614)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_187",
    "data-name": "Ellipse 187",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(1308 3614)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "support-svgrepo-com",
    transform: "translate(1316.423 3622.423)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1020",
    "data-name": "Rectangle 1020",
    width: 32,
    height: 32,
    transform: "translate(-0.423 -0.423)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10709",
    "data-name": "Path 10709",
    d: "M14.841,2A10.526,10.526,0,0,0,4.316,12.526v2.5A3.842,3.842,0,0,0,3,17.788a3.789,3.789,0,0,0,2.552,3.434c1.71,4.092,5.144,7.092,9.289,7.092h3.947V25.683H14.841c-2.973,0-5.671-2.237-7.026-5.776l-.276-.724L6.763,19.1a1.319,1.319,0,0,1-.474-2.447l.658-.382V13.841a1.316,1.316,0,0,1,1.316-1.316H21.42a1.316,1.316,0,0,1,1.316,1.316V20.42H17.354a1.974,1.974,0,1,0-2,2.631H25.367A2.631,2.631,0,0,0,28,20.42V17.788a2.631,2.631,0,0,0-2.631-2.631V12.526A10.526,10.526,0,0,0,14.841,2Z",
    transform: "translate(0.947 0.631)",
    fill: "#399772"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerSupport);
export default __webpack_public_path__ + "static/media/CustomerSupport.9411b56909a8c6f7a58ca9aa8476e35f.svg";
export { ForwardRef as ReactComponent };